// extracted by mini-css-extract-plugin
export default {"root":"_2t6dA-UU","left":"_2OB6to60","right":"_1I5ouIZT","edit":"_3cRMQhlT","shortcut":"_3_DCekfu","message":"_3GdoSigS"};